import React, { useEffect } from 'react';
import { Redirect as Redirect$1 } from 'react-router';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Redirect = function Redirect(_ref) {
  var to = _ref.to,
      props = _objectWithoutPropertiesLoose(_ref, ["to"]);

  var path = typeof to === "object" ? to.pathname : to;
  var isExternalInBrowser = /^http(s?)/.test(path) && process && process.browser;
  useEffect(function () {
    if (isExternalInBrowser) {
      window.location.replace(path);
    }
  }, [path, isExternalInBrowser]);
  return isExternalInBrowser ? null : React.createElement(Redirect$1, _extends({}, props, {
    to: to
  }));
};

export default Redirect;
//# sourceMappingURL=index.esm.js.map
